import { Body, Box, Icon } from '.'

export const Pill = ({ leftIcon, rightIcon, iconSize = 32, height = 48, fontWeight, background, color, children, maxWidth, onRightIconClick, ...props }) => (
  <Box
    height={height}
    r={24}
    p="0 24px"
    gap={8}
    alignItems="center"
    border={`1px solid ${color}`}
    background={background}
    {...props}
  >
    {leftIcon && <Icon
      fill={color}
      icon={leftIcon}
      size={iconSize}
    />}
    <Body
      color={color}
      {...(maxWidth && {
        maxWidth,
        noWrap: true,
        overflow: 'ellipsis',
        style: { display: 'inline-block' }
      })}
      weight={fontWeight}
    >
      {children}
    </Body>
    {rightIcon &&
      <Box
        onClick={onRightIconClick}
        style={onRightIconClick ? { cursor: 'pointer' } : undefined}
      >
        <Icon
          fill={color}
          icon={rightIcon}
          size={iconSize}
          onClick={onRightIconClick}
        />
      </Box>
    }
  </Box>
)